import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberFormat'
})
export class NumberFormatPipe implements PipeTransform {

  transform(number: any, numberOfDecimal: any, decimalSeparator: any, thousandSeparator:any): any {
    let re = '\\d(?=(\\d{' + 3 + '})+' + (numberOfDecimal > 0 ? '\\D' : '$') + ')',
      num = Number(number).toFixed(Math.max(0, ~~numberOfDecimal));

    return (decimalSeparator ? num.replace('.', decimalSeparator) : num).replace(new RegExp(re, 'g'), '$&' + (thousandSeparator || ','));
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/number-format.pipe.ts